module.exports = __webpack_public_path__ + "img/icon-trash.325c4520.svg";